module.exports = __webpack_public_path__ + "img/icon-milestone.44552e04.svg";